import {
  OPERATOR_ROLE,
  FINANCE_ROLE,
  DEVELOPER_ROLE,
  READ_ONLY_ROLE,
} from './AppConstants';

export const EXTRA_PERMISSIONS = [
  {
    key: 'divider-1',
    actions: {
      view: [DEVELOPER_ROLE],
    },
    type: 'workspace',
  },
  {
    key: 'divider-2',
    actions: {
      view: [OPERATOR_ROLE, FINANCE_ROLE, READ_ONLY_ROLE],
    },
    permissions: {
      view: ({ user }) => user.operationCountry === 'BR',
    },
    type: 'workspace',
  },
  {
    key: 'open-finance',
    actions: {
      view: [OPERATOR_ROLE, FINANCE_ROLE, READ_ONLY_ROLE],
    },
    permissions: {
      view: ({ user }) => user.country === 'BR'
      ,
    },
    type: 'workspace',
  },
];

export const MANAGE_PERMISSIONS = [
  { key: 'settings' },
  { key: 'profile' },
  { key: 'profile-my-profile' },
  { key: 'profile-security' },
  { key: 'relevant-links' },
  { key: 'relevant-links-live-demo' },
  { key: 'relevant-links-widget' },
  { key: 'relevant-links-guides-docs' },
  { key: 'developers-index' },
];
